import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/svg/0b25363450c5afe3b3f9ba7fe4f4173b.svg")